import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { ComponentProps } from 'types/index';
import { useMobileOrder } from 'lib/hooks/useMobileOrder';
import awardPrizeService from 'lib/services/awardPrizeService';
import { useUserOrderStore } from 'lib/store/userOrderStore';
import { ORDER_STATE } from 'lib/constants/order';
import { addReportPublicParams, report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import { useMobileStore } from 'lib/store/mobileStore';
import { getGiftBtnType } from 'lib/utils/util';
import './index.scss';

export default function OrderButton({ data, commonStyle }: ComponentProps<any>) {
  const { activityId, orderedBtnImg, tobeOrderBtnImg, btnType, openAnimation } = data;
  const mobileInput = useMobileStore((state) => state.inputMobile);
  const userOrderInfo = useUserOrderStore((state) => state.userOrderInfo);
  const { orderFlowPackage } = useMobileOrder();
  const [isOrdered, setIsOrdered] = useState(false);
  useEffect(() => {
    awardPrizeService.registerGiftData(+activityId, btnType);
  }, []);

  useEffect(() => {
    if (userOrderInfo.orderState && userOrderInfo?.orderState >= ORDER_STATE.ORDER_SUCCESS) {
      setIsOrdered(true);
    }
  }, [userOrderInfo]);

  const orderPackage = () => {
    if (isOrdered) return;
    addReportPublicParams({
      orderTriggerType: getGiftBtnType(btnType),
    });
    report(ATTA_REPORT.ORDER.ORDER_CLICK, {
      mobile: mobileInput,
    });
    orderFlowPackage(+activityId);
  };

  return (
    <div
      style={commonStyle}
      className={classNames({
        'order-btn': true,
        'order-btn--animation': openAnimation,
        disabled: isOrdered,
      })}
      onClick={orderPackage}
      data-is-ordered={!!isOrdered}
      data-test-id="order-button"
    >
      <img
        className={classNames('order-btn__img', { disabled: isOrdered })}
        src={isOrdered ? orderedBtnImg : tobeOrderBtnImg}
      />
    </div>
  );
}
